var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1086 9.65552C14.9714 10.7476 14.5397 11.7461 13.8923 12.5706L15.9816 14.6599C17.1445 13.286 17.8954 11.5556 18.0525 9.65569H15.1086V9.65552Z",
    fill: "#CD9643"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92834 14.804V17.7799C11.829 17.6228 13.5586 16.8719 14.9326 15.709L12.8385 13.614C12.0123 14.2502 11.0167 14.675 9.92834 14.804Z",
    fill: "#CD9643"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56616 13.5825L3.43958 15.7091C4.81334 16.872 6.54372 17.6229 8.44433 17.78V14.7924C7.36684 14.6506 6.38129 14.2221 5.56616 13.5825Z",
    fill: "#CD9643"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33871 9.65552H0.319946C0.476511 11.5554 1.22721 13.2858 2.39008 14.6597L4.522 12.5271C3.89378 11.7115 3.47273 10.7286 3.33871 9.65552Z",
    fill: "#CD9643"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52271 5.29866L2.39008 3.16675C1.22721 4.54069 0.476511 6.27089 0.319946 8.17168H3.33871C3.47273 7.09774 3.89378 6.11521 4.52271 5.29866Z",
    fill: "#CD9643"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44439 3.03415V0.0466309C6.54377 0.203906 4.8141 0.954602 3.43945 2.11766L5.56604 4.24424C6.38135 3.60449 7.36689 3.17634 8.44439 3.03415Z",
    fill: "#CD9643"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5283 6.46212L14.8783 5.81137L17.4788 3.21082C18.1975 2.49208 18.1975 1.3276 17.4788 0.60957C16.7608 -0.108464 15.5963 -0.108464 14.8783 0.60957L12.2768 3.21082L11.6268 2.56007C11.2673 2.20132 10.6847 2.20132 10.3263 2.56007C9.96687 2.91935 9.96687 3.50123 10.3263 3.86069L10.976 4.51145L7.7249 7.76293C7.36615 8.12168 7.06402 8.82444 7.05036 9.3323L7.03882 9.75904L7.19166 10.8965L8.32933 11.0501L8.75677 11.0387C9.26392 11.0249 9.96687 10.7229 10.3265 10.3633L13.5775 7.11199L14.2275 7.76204C14.587 8.1215 15.1688 8.1215 15.5283 7.76204C15.8874 7.40347 15.8874 6.82087 15.5283 6.46212ZM9.67557 9.71342C9.48209 9.90691 9.006 10.1121 8.7321 10.1194L8.70015 10.1201L7.96827 9.38893L7.96898 9.35698C7.97697 9.08308 8.18128 8.60628 8.37548 8.4128L11.6268 5.1615L12.9269 6.46212L9.67557 9.71342Z",
    fill: "#CD9643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.ade01e3865325d7a04fd375c43ddf2bb.svg";
export { ForwardRef as ReactComponent };